// RevisionsModal.tsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { dbModernCasinos } from '../../App';
import RevisionView from './RevisionView';

interface Revision {
  id: string;
  timestamp: any; // Firestore Timestamp
  storedBy: string;
  parentData: { [key: string]: any };
  casinosData: any[];
}

interface RevisionsModalProps {
  parentId: string;
  onClose: () => void;
}

const RevisionsModal: React.FC<RevisionsModalProps> = ({ parentId, onClose }) => {
  const [revisions, setRevisions] = useState<Revision[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRevision, setSelectedRevision] = useState<Revision | null>(null);

  useEffect(() => {
    const fetchRevisions = async () => {
      setLoading(true);
      try {
        const revisionsRef = collection(dbModernCasinos, 'casinosets', parentId, 'revisions');
        const q = query(revisionsRef, orderBy('timestamp', 'desc'));
        const qs = await getDocs(q);
        const revs: Revision[] = qs.docs.map(docSnap => {
          const data = docSnap.data();
          return {
            id: docSnap.id,
            timestamp: data.timestamp,
            storedBy: data.storedBy,
            parentData: data.parentData || {},
            casinosData: data.casinosData || []
          };
        });
        setRevisions(revs);
      } catch (error: any) {
        console.error("Error fetching revisions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRevisions();
  }, [parentId]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {selectedRevision ? (
        <RevisionView
          revision={selectedRevision}
          onClose={() => setSelectedRevision(null)}
        />
      ) : (
        <div
          style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '20px',
            width: '80%',
            maxWidth: '800px',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}
        >
          <h2>Revisions</h2>
          {loading ? (
            <p>Loading revisions...</p>
          ) : revisions.length === 0 ? (
            <p>No revisions found.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: '8px', border: '1px solid #ddd' }}>Date Stored</th>
                  <th style={{ padding: '8px', border: '1px solid #ddd' }}>Stored By</th>
                  <th style={{ padding: '8px', border: '1px solid #ddd' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {revisions.map(rev => (
                  <tr key={rev.id}>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                      {new Date(rev.timestamp.seconds * 1000).toLocaleString()}
                    </td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                      {rev.storedBy}
                    </td>
                    <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <button
                        onClick={() => setSelectedRevision(rev)}
                        style={{
                          padding: '6px 10px',
                          backgroundColor: '#007BFF',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        Open Revision
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <div style={{ textAlign: 'right', marginTop: '20px' }}>
            <button
              onClick={onClose}
              style={{
                padding: '8px 12px',
                background: '#007BFF',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RevisionsModal;
